import VolumeOffIcon from "@mui/icons-material/VolumeOff"
import VolumeUpIcon from "@mui/icons-material/VolumeUp"
import { IconButton } from "@mui/material"
import { useSfxAPI, useSfxData } from "../../sfx/context/SfxProvider"

export const UIMute = () => {
  const { isMuted } = useSfxData()
  const { mute, unMute } = useSfxAPI()

  const handleSfx = () => {
    if (isMuted) unMute()
    else mute()
  }

  return (
    <IconButton onClick={handleSfx} sx={{ pointerEvents: "auto" }}>
      {isMuted ? (
        <VolumeOffIcon color="primary" sx={{ fontSize: "1.2em" }} />
      ) : (
        <VolumeUpIcon color="primary" sx={{ fontSize: "1.2em" }} />
      )}
    </IconButton>
  )
}
